import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Environmental_Report_Table = ({ setEdit }) => {
  const data = [
    {
      date: "01 Jan 2025",
      instrumentId: "INS101",
      instrumentName: "Coal Testing Machine",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "12/11/2026",
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS102",
      instrumentName: "Coal Testing Machine",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "10/11/2025",
    },
    {
      date: "08 Jan 2025",
      instrumentId: "INS103",
      instrumentName: "Laboratory Moisture Analyzer",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "08/11/2025",
    },
    {
      date: "14 Jan 2025",
      instrumentId: "INS104",
      instrumentName: "Volatile Matter Tester",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "14/11/2025",
    },
    {
      date: "12 Jan 2025",
      instrumentId: "INS105",
      instrumentName: "Proximate Analyzer",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "12/11/2026",
    },
    {
      date: "12 Jan 2025",
      instrumentId: "INS106",
      instrumentName: "Coal Testing Machine",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "12/11/2026",
    },
    {
      date: "01 Jan 2025",
      instrumentId: "INS107",
      instrumentName: "Coal Testing Machine",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "12/11/2026",
    },
    {
      date: "10 Jan 2025",
      instrumentId: "INS108",
      instrumentName: "Laboratory Moisture Analyzer",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "12/11/2026",
    },
    {
      date: "08 Jan 2025",
      instrumentId: "INS109",
      instrumentName: "Volatile Matter Tester",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "12/11/2026",
    },
    {
      date: "14 Jan 2025",
      instrumentId: "INS1010",
      instrumentName: "Proximate Analyzer",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "12/11/2026",
    },
    {
      date: "08 Jan 2025",
      instrumentId: "INS1011",
      instrumentName: "Laboratory Moisture Analyzer",
      labTemp: 24.5,
      labRH: 55,
      furnaceTemp: 32,
      furnaceRH: 48,
      certificateNo: "CC-2025-001",
      validUntil: "12/11/2026",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              {" "}
              <tr>
                {" "}
                <th rowspan="2">
                  {" "}
                  <input type="checkbox" />{" "}
                </th>{" "}
                <th rowspan="2">Date</th> <th rowspan="2">Instrument ID</th>{" "}
                <th rowspan="2">Instrument Name</th>{" "}
                <th colspan="2">Lab Room</th> <th colspan="2">Furnace Room</th>{" "}
                <th rowspan="2">Calibration Certificate No</th>{" "}
                <th rowspan="2">Calibration Valid Up To</th>{" "}
              </tr>{" "}
              <tr>
                {" "}
                <th>Temp (°C)</th> <th>RH (%)</th> <th>Temp (°C)</th>{" "}
                <th>RH (%)</th>{" "}
              </tr>{" "}
            </thead>

            <tbody>
              {" "}
              {data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date}</td> <td>{row.instrumentId}</td>{" "}
                  <td>{row.instrumentName}</td> <td>{row.labTemp}</td>{" "}
                  <td>{row.labRH}</td> <td>{row.furnaceTemp}</td>{" "}
                  <td>{row.furnaceRH}</td> <td>{row.certificateNo}</td>{" "}
                  <td>{row.validUntil}</td>{" "}
                </tr>
              ))}{" "}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Environmental_Report_Table;
